import { render, staticRenderFns } from "./GamutCompress.vue?vue&type=template&id=c7cc559a&"
import script from "./GamutCompress.vue?vue&type=script&lang=js&"
export * from "./GamutCompress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports